import { Link } from "react-router-dom";
import { NAV_PLACEMENTS } from '../../routes/navigationConstants';
import { buildNavigation } from '../../util/routeNavigation';

function CopyrightFooter() {
  const links = buildNavigation(NAV_PLACEMENTS.FOOTER);

  return (
    <p className="copyrightFooter m-5">
        <strong>© 2026 Boundary Peak Services LLC</strong><br/>All Rights Reserved<br/>
        {links.map((item, index) => (
          <span key={item.path}>
            {index > 0 ? ' | ' : null}
            <Link to={item.path}>{item.footerLabel ?? item.label}</Link>
          </span>
        ))}
    </p>
  );
}

export default CopyrightFooter;